import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faTimesCircle } from '@fortawesome/pro-regular-svg-icons';
import { cn } from '@v2/shared/lib/utils';
import { AutoRenewalStatus } from './types';

/**
 * Five api statuses, four things to say about them: a renewal that has just been charged
 * is simply active as far as the customer is concerned, and only the api distinguishes
 * the two.
 *
 * Exhaustive, and provably so — DiscountLockOrderItem::getStatus() returns one of five
 * constants out of a switch. A sixth would have to be added here as well, and this
 * failing on it is the point.
 */
const STATUSES: Record<AutoRenewalStatus, { label: string; icon: typeof faCheckCircle; className: string }> = {
  active: { label: 'Active', icon: faCheckCircle, className: 'text-green-600' },
  charged: { label: 'Active', icon: faCheckCircle, className: 'text-green-600' },
  canceled: { label: 'Inactive', icon: faTimesCircle, className: 'text-red-600' },
  'needs-attention': { label: 'Needs Attention', icon: faExclamationTriangle, className: 'text-amber-600' },
  'no-longer-available': { label: 'No Longer Available', icon: faTimesCircle, className: 'text-red-600' },
};

export default function Status({ status }: { status: AutoRenewalStatus }) {
  const { label, icon, className } = STATUSES[status];

  return (
    <span className={cn('mb-2 font-semibold', className)}>
      <FontAwesomeIcon icon={icon} className="mr-1.5" />
      {label}
    </span>
  );
}
